import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { UsersTable } from "./table";

export default function AppUsers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Utilisateurs");
  }, []);

  return (
    <Routes>
      <Route index element={<UsersTable />} />
    </Routes>
  );
}
